<script setup lang="ts">
import { computed } from 'vue'

import { useEditorStore } from '@/stores/Editor'
import { usePublicData } from '@/stores/PublicData'

import BaseList from '@/components/common/BaseList.vue'

const editorStore = useEditorStore()
const publicStore = usePublicData()

const goals = computed(() => editorStore.editor.goalsAchievements[publicStore.lang].goals)
</script>

<template>
  <div class="mb-5">
    <BaseList v-model="goals" />
  </div>
</template>

<style lang="scss" scoped></style>
